import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent, updateCurrentScreen } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import {
    selectApplicationMethodData,
    selectApplicationMethodStatus,
    selectApplicationMethodError,
    initializeAsync,
} from "./applicationMethodSlice";

import {
    Button,
    Box,
    Paper,
    Menu,
    MenuItem,
    Container,
    Typography,
    Card,
    CardContent,
    CardHeader,
    Divider,
    CircularProgress,
} from "@mui/material";

// Add custom imports here
import { useNavigate } from "react-router-dom";
import { InlineText } from "../../components/InlineText";
import { ReactComponent as LightningIcon } from "../../assets/svgs/lightning.svg";
import { ReactComponent as ThumbUpIcon } from "../../assets/svgs/thumb-up.svg";
import { ReactComponent as LockIcon } from "../../assets/svgs/lock.svg";
import { ReactComponent as ShieldIcon } from "../../assets/svgs/shield.svg";
import { useMediaQuery } from "react-responsive";

import "./style.css";
import { PlaidLink } from "../../components/PlaidLink";
import { DesktopHeader } from "../../components/DesktopHeader";

const ApplicationMethod = () => {
    const data = useSelector(selectApplicationMethodData);
    const status = useSelector(selectApplicationMethodStatus);
    const error = useSelector(selectApplicationMethodError);
    const dispatch = useDispatch();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    let userDetails = getUserDetailsNotAsync();
    const navigate = useNavigate();
    const isDesktop = useMediaQuery({ minWidth: 1180 });

    // Add Variables

    const handleManuallyClick = () => {
        let nextLocation = "application"; //userDetails?.applicant?.primaryApplicant ? "quick-check" : "application";

        userDetails.applicant.currentScreen = nextLocation;
        setUserDetailsNotAsync(userDetails);
        updateCurrentScreen(userDetails, nextLocation, "");
        navigate("/" + nextLocation, {});
    };

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync({}));
            if (userDetails.applicant.currentScreen !== "application-method") {
                userDetails = updateCurrentScreen(userDetails, "application-method");
                setUserDetailsNotAsync(userDetails);
            }
        }
    }, [status, dispatch, userDetails]);

    useEffect(() => {
        if (
            userDetails?.applicant?.plaidIdentityVerified &&
            userDetails?.applicant?.plaidIncomeVerified &&
            userDetails?.applicant?.plaidOtherVerified
        ) {
            handleManuallyClick();
        }
    }, []);

    let body = (
        <>
            {status === "initalLoading" || userDetails?.applicant?.plaidIdentityVerified ? (
                // <Container className="ApplicationMethod" sx={{ backgroundColor: "#ffffff", justifyContent: "center" }}>
                //     <CircularProgress
                //         color="success"
                //         sx={{ width: "60px !important", height: "60px !important" }}
                //         thickness="3.9"
                //     />
                //     <PlaidLink></PlaidLink>
                // </Container>
                <></>
            ) : (
                <>
                    <Container className="ApplicationMethod" >
                        <Typography variant="h1" component="h1">
                            Let's verify your identity first!
                        </Typography>
                        <Typography variant="h6" component="h6" sx={{ textAlign: "center" }}>
                            We will verify your identity and pre fill your personal details from the Plaid.
                        </Typography>
                        {/* {isDesktop && <DesktopHeader applicant={userDetails.applicant}></DesktopHeader>} */}
                        {/* <Button
                            onClick={handleManuallyClick}
                            color="primary"
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ height: "45px" }}
                        >
                            Continue applying manually
                        </Button>
                        <Divider sx={{ width: "46%" }}></Divider> */}
                        <PlaidLink></PlaidLink>
                        <Box fullWidth>
                            <InlineText
                                sx={{ mt: "4px" }}
                                text={
                                    <Typography variant="h6" component="h6">
                                        Faster application process by 73.1% with Plaid
                                    </Typography>
                                }
                                icon={<LightningIcon style={{ width: "16px" }}></LightningIcon>}
                            ></InlineText>

                            <InlineText
                                sx={{ mt: "4px" }}
                                text={
                                    <Typography variant="h6" component="h6">
                                        Save 17 minutes worth of your time
                                    </Typography>
                                }
                                icon={<ThumbUpIcon style={{ width: "16px" }}></ThumbUpIcon>}
                            ></InlineText>

                            <InlineText
                                sx={{ mt: "4px" }}
                                text={
                                    <Typography variant="h6" component="h6">
                                        Personal data will not be used without permission
                                    </Typography>
                                }
                                icon={<LockIcon style={{ width: "16px" }}></LockIcon>}
                            ></InlineText>

                            <InlineText
                                sx={{ mt: "4px" }}
                                text={
                                    <Typography variant="h6" component="h6">
                                        Fully secure and encrypted process
                                    </Typography>
                                }
                                icon={<ShieldIcon style={{ width: "16px" }}></ShieldIcon>}
                            ></InlineText>
                        </Box>
                    </Container>
                </>
            )}
        </>
    );

    return getPageContent(body, status, error);
};

export { ApplicationMethod };
